module.exports = __webpack_public_path__ + "img/distanceWedge6.2e7bfcd9.png";